import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Hide initial loader once React app starts rendering
const hideInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => {
      loader.remove();
    }, 300);
  }
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loader after a brief delay to ensure CSS is loaded
setTimeout(hideInitialLoader, 100);
